// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setStorePickupOverlayIsOpen from "@insite/client-framework/Store/Components/StorePickupOverlay/Handlers/SetStorePickupOverlayIsOpen";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import setFulfillmentMethod from "@insite/client-framework/Store/Context/Handlers/SetFulfillmentMethod";
import updatePickUpWarehouse from "@insite/client-framework/Store/Context/Handlers/UpdatePickUpWarehouse";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import setFulfillmentMethodForCart from "@insite/client-framework/Store/Data/Carts/Handlers/SetFulfillmentMethod";
import updatePickUpWarehouseForCart from "@insite/client-framework/Store/Data/Carts/Handlers/UpdatePickUpWarehouse";
import translate from "@insite/client-framework/Translate";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import FindLocationModal, { FindLocationModalStyles } from "@insite/content-library/Components/FindLocationModal";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Radio, { RadioComponentProps } from "@insite/mobius/Radio";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import FieldSetPresentationProps, { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps } from "styled-components";

// Starter Custom Code - >
import RadioGroup, { RadioGroupComponentProps } from "@store/MobiusOverrides/RadioGroup/RadioGroup";
import Typography, { TypographyPresentationProps, TypographyProps } from "@store/MobiusOverrides/Typography/Typography";

import getColor from "@insite/mobius/utilities/getColor";
import { addressProps } from "@store/Themes/common/props/address";
import { useIsSignedInAndhasToBeSignedIn } from "@store/Framework/Store/Context/ContextHooks";
import { checkoutFulfillmentMethodWrapperProps } from "@store/Themes/common/props/checkout";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
// <--- Starter Custom Code

// Store Custom Code - >
import BillingAddressInfoDisplay, {
    BillingAddressInfoDisplayStyles,
} from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/BillingAddressInfoDisplay";
import ShippingAddressInfoDisplay, {
    ShippingAddressInfoDisplayStyles,
} from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/ShippingAddressInfoDisplay";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import MapPin from "@insite/mobius/Icons/MapPin";
import Truck from "@insite/mobius/Icons/Truck";
import Icon from "@store/MobiusOverrides/Icon/Icon";
import useChangeCustomerWithRedirect from "@store/Framework/Common/Hooks/useChangeCustomerAndRedirect";
import useGetShipToAndBillTo from "@store/Framework/Store/Data/Accounts/Hooks/useGetShipToAndBillTo";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import { useCurrentCartState } from "@toolkit/Framework/Store/Data/Carts/CartsHooks";
// <-- bunzl custom code

const enum fields {
    displayStyle = "displayStyle",
    shipToHomeMessage = "shipToHomeMessage",
    storePickUpMessage = "storePickUpMessage",
    // Store Custom Code - >
    showBillToLocation = "showBillToLocation",
    showShipToLocation = "showShipToLocation",
    widgetOrientation = "widgetOrientation",
    // <-- bunzl custom code
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.displayStyle]: string;
        [fields.shipToHomeMessage]: string;
        [fields.storePickUpMessage]: string;
        // Store Custom Code - >
        [fields.showBillToLocation]: boolean;
        [fields.showShipToLocation]: boolean;
        [fields.widgetOrientation]: string;
        // <-- bunzl custom code
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const cart = getCurrentCartState(state).value;
    const session = getSession(state);
    return {
        fulfillmentMethod: cart?.fulfillmentMethod || session.fulfillmentMethod,
        enableWarehousePickup: getSettingsCollection(state).accountSettings.enableWarehousePickup,
        pickUpWarehouse: cart?.defaultWarehouse || session.pickUpWarehouse,
        updateCartInsteadOfContext: cart?.isAwaitingApproval,
        cart,
        session,
        accountSettings: getSettingsCollection(state).accountSettings,
    };
};

const mapDispatchToProps = {
    setFulfillmentMethod,
    updatePickUpWarehouse: makeHandlerChainAwaitable(updatePickUpWarehouse),
    setStorePickupOverlayIsOpen,
    setFulfillmentMethodForCart,
    updatePickUpWarehouseForCart: makeHandlerChainAwaitable(updatePickUpWarehouseForCart),
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme>;

export interface CartFulfillmentMethodSelectorStyles {
    fulfillmentMethodradioGroup?: FieldSetGroupPresentationProps<RadioGroupComponentProps>;
    fulfillmentMethodRadio?: FieldSetPresentationProps<RadioComponentProps>;
    pickUpLocation?: PickUpLocationStyles;
    clickableBoxesText?: TypographyPresentationProps;
    boxesWrapper?: InjectableCss;
    boxWrapper?: InjectableCss;
    selectedBoxWrapper?: InjectableCss;
    clickableBoxLabel?: TypographyPresentationProps;
    pickUpWarehouseLink?: LinkPresentationProps;
    shipToHomeMessage?: TypographyPresentationProps;
    storePickUpMessage?: TypographyPresentationProps;
    findLocationModal?: FindLocationModalStyles;
    // Store Custom Code
    fulfillmentMethodWrapper?: InjectableCss;
    // Store Custom Code - >
    shippingAndPickUpDisplayWrapper?: InjectableCss;
    radioGroupOuterWrapper?: InjectableCss;
    labelWrapper?: InjectableCss;
    addressDisplayStyles?: BillingAddressInfoDisplayStyles & ShippingAddressInfoDisplayStyles;
    // <-- Bunzl Custom Code
}

interface PickUpLocationStyles {
    wrapper?: InjectableCss;
    headerText?: TypographyProps;
    changeLink?: LinkPresentationProps;
    warehouseAddress?: WarehouseAddressInfoDisplayStyles;
    // Store Custom Code
    findLocationModal?: FindLocationModalStyles;
    pickupLocationOuterWrapper?: InjectableCss;
}

interface WarehouseAddressInfoDisplayStyles {
    wrapper?: InjectableCss;
    nameText?: TypographyProps;
    address?: AddressInfoDisplayStyles;
}

export const cartFulfillmentMethodStyles: CartFulfillmentMethodSelectorStyles = {
    // Store Custom Code - >
    radioGroupOuterWrapper: {
        css: css`
            width: 100%;
        `,
    },

    shippingAndPickUpDisplayWrapper: {
        css: css`
            /* Bunzl Custom Code */
            background-color: ${getColor("common.shadesLight")};
            margin-top: ${pxToRem(20)};
            padding-top: ${pxToRem(20)};
            border-top: ${pxToRem(1)} solid ${getColor("common.border")};
            flex-direction: column;
            display: flex;
            gap: ${pxToRem(8)};
            justify-content: center;
        `,
    },
    addressDisplayStyles: {
        heading: addressProps.title,
    },
    // <-- Bunzl Custom Code

    pickUpLocation: {
        wrapper: {
            css: css`
                margin-top: ${pxToRem(20)};
                padding-top: ${pxToRem(20)};
                border-top: ${pxToRem(1)} solid ${getColor("common.border")};
            `,
        },
        // Store Custom Code - >
        headerText: {
            ...addressProps.title,
            css: css`
                ${addressProps.title?.css};
                margin-block: 0;
            `,
        },
        // <-- Bunzl Custom Code
        changeLink: addressProps.link,
        warehouseAddress: {
            wrapper: addressProps.wrapper,
            nameText: addressProps.name,
        },
    },
    boxesWrapper: {
        css: css`
            display: flex;
            gap: 8px;
        `,
    },
    boxWrapper: {
        css: css`
            padding: 15px;
            margin-top: 15px;
            display: flex;
            flex-direction: column;
            width: 50%;
            align-items: flex-start;
            cursor: pointer;
        `,
    },
    selectedBoxWrapper: {
        css: css`
            border: 2px solid ${getColor("secondary.main")};
            padding: 15px;
            margin-top: 15px;
            display: flex;
            flex-direction: column;
            width: 50%;
            align-items: flex-start;
            cursor: pointer;
        `,
    },
    clickableBoxLabel: {
        css: css`
            margin-bottom: 8px;
        `,
    },
    fulfillmentMethodWrapper: {
        ...checkoutFulfillmentMethodWrapperProps,
    },
    fulfillmentMethodradioGroup: {
        labelProps: {
            variant: "h2",
            size: "1rem !important",
        },
        css: css`
            > legend {
                margin-bottom: 0.625rem;
            }
        `,
    },
    /* Store Custom Code */
    labelWrapper: {
        css: css`
            display: flex;
            gap: ${pxToRem(8)};
            margin-bottom: ${pxToRem(16)};
        `,
    },
};
// Store Custom Code - >
export const horizontalStyles: CartFulfillmentMethodSelectorStyles = {
    ...cartFulfillmentMethodStyles,
    fulfillmentMethodWrapper: {
        ...cartFulfillmentMethodStyles.fulfillmentMethodWrapper,
        css: css`
            display: flex;
            background-color: ${getColor("common.shadesLight")};
            justify-content: space-between;
            border-radius: ${({ theme }) => theme.design.radius.medium};
            padding: 1rem;
        `,
    },
    shippingAndPickUpDisplayWrapper: {
        css: css`
            width: 100%;
            display: flex;

            flex-direction: column;
            align-items: center;
            gap: ${pxToRem(8)};
            margin-left: ${pxToRem(20)};
            padding-left: ${pxToRem(20)};
            border-left: ${pxToRem(1)} solid ${getColor("common.border")};
        `,
    },
    fulfillmentMethodradioGroup: {
        css: css`
            ${cartFulfillmentMethodStyles.fulfillmentMethodradioGroup?.css}
            width: fit-content;
            margin-left: auto;
            margin-right: auto;
        `,
    },
    pickUpLocation: {
        ...cartFulfillmentMethodStyles.pickUpLocation,
        pickupLocationOuterWrapper: {
            css: css`
                width: 100%;
                border-left: 1px solid ${getColor("common.border")};
                padding-left: 20px;
                margin-left: 20px;
            `,
        },
        wrapper: {
            css: css`
                width: fit-content;
                margin-left: auto;
                margin-right: auto;
                border: none;
            `,
        },

        warehouseAddress: {
            ...cartFulfillmentMethodStyles.pickUpLocation?.warehouseAddress,
        },
    },
};

// <-- bunzl custom code
const CartFulfillmentMethodSelector: FC<Props> = ({
    fulfillmentMethod,
    enableWarehousePickup,
    pickUpWarehouse,
    session,
    accountSettings,
    fields,
    setFulfillmentMethod,
    updatePickUpWarehouse,
    setStorePickupOverlayIsOpen,
    theme,
    updateCartInsteadOfContext,
    setFulfillmentMethodForCart,
    updatePickUpWarehouseForCart,
}) => {
    // Store Custom Code - moved
    let styles = cartFulfillmentMethodStyles;
    const { value: cart } = usePersistentDataView(useCurrentCartState()); // Starter Custom Code
    const { navigateToChangeCustomerPageWithRedirect } = useChangeCustomerWithRedirect();

    const [isFindLocationOpen, setIsFindLocationOpen] = React.useState(false);
    // Store Custom Code - >
    const { billTo, shipTo } = useGetShipToAndBillTo();
    const { showBillToLocation, showShipToLocation, widgetOrientation } = fields;
    if (widgetOrientation === "horizontal") {
        styles = horizontalStyles;
    }
    // <-- bunzl custom code
    const isSignedInAndhasToBeSignedIn = useIsSignedInAndhasToBeSignedIn(); // Starter Custom Code
    const toasterContext = React.useContext(ToasterContext);
    if (
        !cart ||
        !accountSettings ||
        !accountSettings.enableWarehousePickup ||
        /* Starter Custom Code */ !isSignedInAndhasToBeSignedIn
    ) {
        return null;
    }

    const { shipToHomeMessage, storePickUpMessage } = fields;
    const displayStyle = fields.displayStyle || "radioButton";
    const fulfillmentMethodChangeHandler = (fulfillmentMethod: string) => {
        if (updateCartInsteadOfContext && cart) {
            setFulfillmentMethodForCart({
                cart,
                fulfillmentMethod: fulfillmentMethod as "Ship" | "PickUp",
            });
        } else {
            setFulfillmentMethod({ fulfillmentMethod: fulfillmentMethod as "Ship" | "PickUp" });
        }
    };

    const handlePickUpAddressChange = async (pickUpWarehouse: WarehouseModel) => {
        if (updateCartInsteadOfContext && cart) {
            await updatePickUpWarehouseForCart({ cart, pickUpWarehouse });
        } else {
            await updatePickUpWarehouse({ pickUpWarehouse });
        }
        toasterContext.addToast({
            body: translate("Pick Up Address Updated"),
            messageType: "success",
        });
    };

    const handleOpenFindLocation = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.stopPropagation();

        if (theme.storePickup?.useOverlay) {
            setStorePickupOverlayIsOpen({ isOpen: true });
            return;
        }

        setIsFindLocationOpen(true);
    };
    // bunzl deleted code, modal moved to child component
    return (
        <>
            {displayStyle === "radioButton" && (
                <StyledWrapper {...styles.fulfillmentMethodWrapper /* Starter Custom Code */}>
                    <StyledWrapper {...styles.radioGroupOuterWrapper /* Store Custom Code */}>
                        <RadioGroup
                            /* Store Custom Code - Start */
                            label={
                                <StyledWrapper {...styles.labelWrapper}>
                                    <Icon color="primary" size={18} src={Truck} />
                                    <Typography>{translate("Fulfillment Method")}</Typography>
                                </StyledWrapper>
                            }
                            /* Store Custom Code - End */
                            value={cart.fulfillmentMethod}
                            onChangeHandler={event => fulfillmentMethodChangeHandler(event.currentTarget.value)}
                            {...styles.fulfillmentMethodradioGroup}
                            data-test-selector="cartFulfillmentMethod"
                        >
                            <Radio
                                value={FulfillmentMethod.Ship}
                                {...styles.fulfillmentMethodRadio}
                                data-test-selector="fulfillmentMethod_ship"
                            >
                                {translate("Ship")}
                            </Radio>
                            <Radio
                                value={FulfillmentMethod.PickUp}
                                {...styles.fulfillmentMethodRadio}
                                data-test-selector="fulfillmentMethod_pickUp"
                            >
                                {translate("Pick Up")}
                            </Radio>
                        </RadioGroup>
                    </StyledWrapper>
                    {/* Store Custom Code - > */}
                    {showBillToLocation && (
                        <StyledWrapper {...styles.shippingAndPickUpDisplayWrapper}>
                            <BillingAddressInfoDisplay
                                extendedStyles={styles.addressDisplayStyles}
                                billTo={billTo}
                                onEdit={() => {}}
                            />
                        </StyledWrapper>
                    )}
                    {showShipToLocation && (
                        <StyledWrapper {...styles.shippingAndPickUpDisplayWrapper}>
                            <ShippingAddressInfoDisplay
                                shipTo={shipTo}
                                onEdit={() => {}}
                                extendedStyles={styles.addressDisplayStyles}
                            />
                            <Link
                                onClick={navigateToChangeCustomerPageWithRedirect}
                                {...styles.pickUpLocation?.changeLink}
                                data-test-selector="cart_pickUpLocation_findLocation"
                            >
                                {translate("Change Customer")}
                            </Link>
                        </StyledWrapper>
                    )}

                    {/* <-- bunzl custom code */}
                    {cart.fulfillmentMethod === FulfillmentMethod.PickUp && session.pickUpWarehouse && (
                        <PickUpLocation
                            // Store Custom Code
                            styles={styles}
                            onChange={handlePickUpAddressChange}
                            warehouse={session.pickUpWarehouse}
                            openFindLocation={handleOpenFindLocation}
                        />
                    )}
                </StyledWrapper>
            )}
            {displayStyle === "clickableBoxes" && (
                <>
                    <Typography {...styles.clickableBoxesText}>
                        {siteMessage("Cart_FulfillmentMethodMessage")}
                    </Typography>
                    <StyledWrapper {...styles.boxesWrapper}>
                        <StyledWrapper
                            {...(cart.fulfillmentMethod === FulfillmentMethod.Ship
                                ? styles.selectedBoxWrapper
                                : styles.boxWrapper)}
                            onClick={() => fulfillmentMethodChangeHandler(FulfillmentMethod.Ship)}
                        >
                            {/* Store Custom Code */}
                            <Typography {...styles.clickableBoxLabel}>{translate("Ship to home")}</Typography>
                            <Typography {...styles.shipToHomeMessage}>
                                {parse(shipToHomeMessage || "", parserOptions)}
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper
                            {...(cart.fulfillmentMethod === FulfillmentMethod.PickUp
                                ? styles.selectedBoxWrapper
                                : styles.boxWrapper)}
                            onClick={() => fulfillmentMethodChangeHandler(FulfillmentMethod.PickUp)}
                        >
                            <Typography {...styles.clickableBoxLabel}>
                                {session.pickUpWarehouse ? translate("Store pickup at ") : translate("Store pickup")}
                                {session.pickUpWarehouse && (
                                    <Link onClick={handleOpenFindLocation} {...styles.pickUpWarehouseLink}>
                                        {session.pickUpWarehouse.description || session.pickUpWarehouse.name}
                                    </Link>
                                )}
                            </Typography>
                            <Typography {...styles.storePickUpMessage}>
                                {parse(storePickUpMessage || "", parserOptions)}
                            </Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                </>
            )}
            {/* bunzl deleted code */}
        </>
    );
};

interface PickUpLocationProps {
    warehouse: WarehouseModel;
    openFindLocation: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    // Store Custom Code
    styles: CartFulfillmentMethodSelectorStyles;
    onChange: (address: WarehouseModel) => void;
}
// Store Custom Code
const PickUpLocation: FC<PickUpLocationProps> = ({ warehouse, styles, onChange }) => {
    const componentStyles = styles.pickUpLocation || {};
    const [isFindLocationOpen, setIsFindLocationOpen] = React.useState(false);
    const handleOpenFindLocation = () => {
        setIsFindLocationOpen(true);
    };
    const handleFindLocationModalClose = () => setIsFindLocationOpen(false);
    const handleWarehouseSelected = (warehouse: WarehouseModel) => {
        setIsFindLocationOpen(false);
        onChange(warehouse);
    };

    return (
        <>
            {/* Store Custom Code */}
            <StyledWrapper {...componentStyles.pickupLocationOuterWrapper} data-test-selector="cart_pickUpLocation">
                <StyledWrapper {...componentStyles.wrapper} data-test-selector="cart_pickUpLocation">
                    {/* Store Custom Code - Start */}
                    <StyledWrapper {...cartFulfillmentMethodStyles.labelWrapper}>
                        <Icon color="primary" size={18} src={MapPin} />
                        <Typography {...componentStyles.headerText}>{translate("Pick Up Location")}</Typography>
                    </StyledWrapper>
                    {/* Store Custom Code - End */}
                    <Link
                        onClick={handleOpenFindLocation}
                        {...componentStyles.changeLink}
                        data-test-selector="cart_pickUpLocation_findLocation"
                    >
                        {translate("Change")}
                    </Link>
                    {/* Store Custom Code */}
                    <WarehouseAddressInfoDisplay styles={styles} warehouse={warehouse} />
                </StyledWrapper>
            </StyledWrapper>
            <FindLocationModal
                modalIsOpen={isFindLocationOpen}
                onWarehouseSelected={handleWarehouseSelected}
                onModalClose={handleFindLocationModalClose}
                forCart
                extendedStyles={componentStyles.findLocationModal}
            />
        </>
    );
};

interface WarehouseAddressInfoDisplayProps {
    warehouse: WarehouseModel;
    // Store Custom Code
    styles: CartFulfillmentMethodSelectorStyles;
}

// Store Custom Code
const WarehouseAddressInfoDisplay: FC<WarehouseAddressInfoDisplayProps> = ({ warehouse, styles }) => {
    const componentStyles =
        styles.pickUpLocation && styles.pickUpLocation.warehouseAddress ? styles.pickUpLocation.warehouseAddress : {};

    return (
        <StyledWrapper {...componentStyles.wrapper}>
            <Typography {...componentStyles.nameText} data-test-selector="cart_warehouseName">
                {warehouse.description || warehouse.name}
            </Typography>
            <AddressInfoDisplay
                address1={warehouse.address1}
                address2={warehouse.address2}
                city={warehouse.city}
                state={warehouse.state}
                postalCode={warehouse.postalCode}
                phone={warehouse.phone}
                extendedStyles={componentStyles.address}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CartFulfillmentMethodSelector),
    definition: {
        group: "Common",
        displayName: "Fulfillment Method Selector",
        icon: "truck",
        fieldDefinitions: [
            {
                name: fields.displayStyle,
                displayName: "Display Style",
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Radio Button",
                        value: "radioButton",
                    },
                    {
                        displayName: "Clickable Boxes",
                        value: "clickableBoxes",
                    },
                ],
                defaultValue: "radioButton",
                fieldType: "General",
            },
            {
                name: fields.shipToHomeMessage,
                displayName: "Ship to home message",
                defaultValue: "",
                editorTemplate: "RichTextField",
                fieldType: "Contextual",
                extendedConfig: { height: 100 },
                isVisible: item => item?.fields[fields.displayStyle] === "clickableBoxes",
            },
            {
                name: fields.storePickUpMessage,
                displayName: "Store PickUp message",
                defaultValue: "",
                editorTemplate: "RichTextField",
                fieldType: "Contextual",
                extendedConfig: { height: 100 },
                isVisible: item => item?.fields[fields.displayStyle] === "clickableBoxes",
            },
            // Store Custom Code - >
            {
                name: fields.showBillToLocation,
                displayName: "Show Bill to Location",
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                defaultValue: false,
            },
            {
                name: fields.showShipToLocation,
                displayName: "Show Ship To Location",
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                defaultValue: false,
            },
            {
                name: fields.widgetOrientation,
                displayName: "Widget Orientation",
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Horizontal",
                        value: "horizontal",
                    },
                    {
                        displayName: "Vertical",
                        value: "vertical",
                    },
                ],
                defaultValue: "vertical",
                fieldType: "Contextual",
            },
            // <-- bunzl custom code
        ],
    },
};

export default widgetModule;
